/**
 * Texts of the extranet chrome (sidebar, layout, top bar, page header) —
 * config, never inline JSX strings.
 */

/** Sidebar texts. */
export const SIDEBAR_TEXT = {
  ariaLabel: 'Navigation de l’espace client',
  collapse: 'Réduire le menu',
  expand: 'Déplier le menu',
} as const;

/** Layout texts. */
export const LAYOUT_TEXT = {
  drawerTitle: 'Menu',
} as const;

/** Top bar texts. */
export const HEADER_TEXT = {
  openMenu: 'Ouvrir le menu',
  clientPrefix: 'Espace client ·',
  notifications: 'Notifications',
  /** Accessible name of the bell, with the pending pieces count. */
  notificationsAria: (count: number): string =>
    count > 0
      ? `Notifications — ${String(count)} pièce${count > 1 ? 's' : ''} en attente`
      : 'Notifications — aucune pièce en attente',
  userMenu: 'Menu utilisateur',
  logout: 'Se déconnecter',
} as const;

/** Page header texts. */
export const PAGE_HEADER_TEXT = {
  back: 'Retour',
  home: 'Accueil',
  breadcrumbLabel: "Fil d'Ariane",
} as const;
